import { Box, styled } from "@mui/material";

export const StyledMedia = styled(Box)(({ theme }) => ({
    "& img, video": {
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shape.boxShadow,
    },
    "& video": { maxHeight: "300px" },
}));
